import React,{ useState, useEffect, useCallback} from 'react';
import { useSelector, useDispatch, connect} from 'react-redux';
import { Divider, Loader, Modal, Button  } from 'rsuite';
import { isNoCyrilicFound}  from '../../../../app/common/services/vehicle.service';
import {insCompBgNames} from '../../../../app/common/types/insCompTypes';
import * as actionsPolicy  from '../../../../app/actions/policy';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon, Info2Icon} from '../svg/iconsSvg';
import { NuInsInputTextLabel, NuInsInputNumLabel, NuInsSelectGroupLabel } from '../elements/inputFieldsLabel';
import countryCodes from './common/countryCodes.json';
import SelectDeliveryAddress from './elements/SelectDeliveryAddress';

const countryCodesOptions = countryCodes.map((doc, i) => ({label: doc["COUNTRY_NAME"], value: doc["PHONE_CODE"], key: i+1, code: doc["COUNTRY_CODE"] , order: doc["VIEW_ORDER"]}));


const DeliveryDetails = ({onBack, onForward, getInsOffersForCompany, updateShipmentDetails, style}) => {

    const dispatch = useDispatch();

    const auth = useSelector(state => state.auth);

    const insCompanies    = useSelector(state => state.insCompanies);
    const userDetails     = useSelector(state => state.userDetails);

    const {revisedOffer, selectedOffer} = useSelector(state => state.insOffers);

    let revisedPrice = revisedOffer?.installments ? revisedOffer.installments.reduce((acc, val)=>(acc+val), 0) : null;
    revisedPrice = Number.parseFloat(revisedPrice).toFixed(2);

    const shipmentDetails = useSelector(state => state.shipmentDetails);
    const {receiverName , deliveryAddress} = shipmentDetails || {};

    const {insCompany, installments, insuranceId} = revisedOffer || {};

   // console.log(selectedOffer, revisedOffer)

    const [revisedOfferModal, setRevisedOfferModal] = useState(false);
    const [deliveryAddressModal, setDeliveryAddressModal] = useState(false);

    const [checkFields, setCheckFields] = useState({});

    const [loading, setLoading] = useState(false);

    const [deliveryPhone, setDeliveryPhone] = useState({countryCode: '359', phoneNo: null});

    const inputFields = ['receiverName', 'phoneNo'];
    const errorMsg    = "Полето е задължително";


    const isOfferChanged = useCallback(() => {
        const priceSelected = selectedOffer?.installments ? selectedOffer.installments.reduce((acc, val)=>(acc+val),0) : 0;
        const priceRevised = revisedOffer?.installments ? revisedOffer.installments.reduce((acc, val)=>(acc+val),0) : 0;

        return priceSelected !== priceRevised ;
    }, [selectedOffer, revisedOffer])

    useEffect(() => {
        const populateInitialData = async () => {
            if(selectedOffer && !revisedOffer?.totalAmountEUR) {
                //console.log('test1')
                setLoading(true);
                await dispatch(actionsPolicy.getRevisedOffer(insuranceId));
                setLoading(false);
            } else if (selectedOffer && revisedOffer?.totalAmountEUR) {
                const instLengthSelected = selectedOffer?.installments?.length;
                const instLengthRevised = revisedOffer?.installments?.length;

                if((revisedOffer?.insCompany !== selectedOffer?.insCompany) || (instLengthSelected !== instLengthRevised)) {
                   // console.log('test2')
                    setLoading(true);
                    await dispatch(actionsPolicy.getRevisedOffer(insuranceId));
                    setLoading(false);
                } else if(isOfferChanged()) {
                    //console.log('test3')
                    setRevisedOfferModal(true);
                }
                setLoading(false);
            }
        }

        populateInitialData();

    }, [revisedOffer, dispatch, selectedOffer, isOfferChanged]);

    useEffect(() => {
        if(userDetails?.firstNameCyrillic && userDetails?.lastNameCyrillic && !shipmentDetails?.receiverName) {
            updateShipmentDetails({receiverName: `${userDetails.firstNameCyrillic} ${userDetails.lastNameCyrillic}`});
        }

        if(userDetails.phone && !shipmentDetails?.receiverPhone) {
            const phone = userDetails.phone;
            updateShipmentDetails({receiverPhone: `${phone.countryCode}${phone.phoneNo}`});
            setDeliveryPhone({countryCode: phone.countryCode, phoneNo: phone.phoneNo});
        }

       // console.log(shipmentDetails?.deliveryAddress)

    }, [userDetails, shipmentDetails, updateShipmentDetails]);

    const onChangeHandler = (field, data) => {
        switch(field) {
            case 'countryCode':
                data = data.replace(/[^0-9]/,"");
                updateShipmentDetails({'receiverPhone': `${data}${deliveryPhone?.phoneNo}`});
                setDeliveryPhone({countryCode: data, phoneNo: deliveryPhone?.phoneNo});
                return
            case 'phoneNo':
                updateShipmentDetails({'receiverPhone': `${deliveryPhone?.countryCode}${data}`});
                setDeliveryPhone({countryCode: deliveryPhone?.countryCode, phoneNo: data});
                return

            default:
                updateShipmentDetails({[field]: data });
                return;
        } 
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const phoneValidation = () => {
        if(deliveryPhone.countryCode  && deliveryPhone.phoneNo && deliveryPhone.phoneNo.length === 9  ) return false;

        return true;
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = shipmentDetails[field] ? isNoCyrilicFound(shipmentDetails[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !shipmentDetails[field]);
            case 'phoneNo':
                return (checkFields[field] || allFields) && (!deliveryPhone[field] || phoneValidation());
            default:
                return (checkFields[field] || allFields) && !shipmentDetails[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${shipmentDetails[field] ? 'на кирилица' : ''}`;
            case 'phoneNo':
                if(!deliveryPhone[field]) return errorMsg;
                if(deliveryPhone[field] && phoneValidation()) return "Невалиден номер";
                break
            default:
                return errorMsg;
        }
    }

    const closeModal = () => {
        setRevisedOfferModal(false);
        setDeliveryAddressModal(false);
    }

    const goBack = () => {
        const backTo = auth?.loginToken ? 9 : 12;
        onBack(backTo);
    }

    const goForward = () => {
        onForward(14);
    }

    const getInsOffers = (insCompanies) => {
        if (!insCompanies) return;

        insCompanies.forEach(company => {
            getInsOffersForCompany(company, true);
        });
    };

    const returnToOffers = async () => {
        await dispatch(actionsPolicy.clearInsOffers(insCompanies));
        setLoading(true);
        await dispatch(actionsPolicy.getRevisedOffer(insuranceId));

        getInsOffers(insCompanies);

        onForward(6)
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if (field === 'phoneNo') {
                if(checkForError(field, 'phoneNo', true)) return false;
            }
        }

        return true;
    }

    const submitHandler = async () => {
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(valdateAllFields() && deliveryAddress) {
            goForward();
        } else if(valdateAllFields() && !deliveryAddress) {
            setDeliveryAddressModal(true)
        }
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>
            </div>
            <Divider />

            <h6 style={{paddingLeft:"2rem", fontWeight: '500', marginBottom: '20px'}}>Доставка</h6>
            
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('receiverName', data)} onBlur={()=>onBlurHandler('receiverName')} 
                placeholder={"Получател"} 
                value={receiverName} 
                error={checkForError('receiverName', 'cyrilic')} 
                errorMsg={generateErrorMsg('receiverName', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
      
            <div className="address-telephone-container" style={{marginBottom: '20px'}}>          
                <NuInsSelectGroupLabel onChange={(data)=>onChangeHandler('countryCode', data)}
                value={'+' + deliveryPhone.countryCode}
                placeholder={"Телефон"}
                options={countryCodesOptions} 
                ></NuInsSelectGroupLabel>
                <div style={{marginLeft:'4px'}}>
                    <NuInsInputNumLabel onChange={(data)=>onChangeHandler('phoneNo', data)} onBlur={()=>onBlurHandler('phoneNo')}
                                        validationType={"vin"} slice={9} 
                                        value={deliveryPhone.phoneNo}
                                        placeholder={" "}                                  
                                        error= {checkForError('phoneNo', 'phoneNo')}
                                        errorMsg={generateErrorMsg('phoneNo', 'phoneNo')}
                                        /> 
                </div>       
            </div>
          
            <SelectDeliveryAddress />
            <Divider />
            <button className="nuIns-btn nuIns-btn-main nuIns-btn-mx" type="submit" onClick={submitHandler}>Продължи</button>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}
      
            {/* Modal for revised offer */}
            <Modal size="xs" show={revisedOfferModal} onHide={() => closeModal()} className='delivery-modal'>
                <Modal.Body style={{margin: 0, padding: '5px 20px 20px', maxHeight: 'unset'}}>
                    <div style={{display: 'flex'}}>
                        <Info2Icon size={64}/>
                        <p className='delivery-modal-text'>
                            Цената на офертата е подменена, на база на данните за собственика на превозното средство </p>
                    </div>
                    <div className='delivery-modal-info'>
                        <div className='info-text'>{insCompBgNames[insCompany]}</div>
                        <div className='info-text'>{installments?.length ? installments?.length : null} вноски</div>
                        <div className='info-text'>{installments?.length ? revisedPrice : null} лв.</div>
                    </div>
                </Modal.Body>
                <Divider style={{margin: 0}} />
                <Modal.Footer className='delivery-modal-buttons'>
                    <Button appearance="subtle" onClick={() => closeModal()} >Към плащане</Button>
                    <Button appearance="subtle" onClick={() => returnToOffers()} style={{marginLeft: 0}}>Актуални оферти</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal for delivery address */}
            <Modal size="xs" show={deliveryAddressModal} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Избери адрес за доставка</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default connect(null, {...actionsPolicy})(DeliveryDetails);